import { AuthContext } from 'contextProviders/AuthContext';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export function SignOut(): JSX.Element {
    const { signOutNeve } = React.useContext(AuthContext);
    const navigate = useNavigate();

    React.useEffect(() => {
        const doSignOut = async () => {
            await signOutNeve();
            navigate('/', { replace: true });
        };
        doSignOut();
    }, []); //eslint-disable-line

    return <></>;
}
